import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM } from '../../../../../constants'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { AutotaxErrors as AutotaxErrorsUnified } from './AutotaxErrors'
import { AutotaxErrorsLegacy } from './AutotaxErrorsLegacy'
import type { AutotaxErrorsProps } from './useAutotaxErrorsModel'

export const AutotaxErrors: React.FC<AutotaxErrorsProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <AutotaxErrorsUnified {...props} />
  ) : (
    <AutotaxErrorsLegacy {...props} />
  )
}
